import {BlogURL, PlanName, PlanType} from 'selectra/constants';

import NavBarItem from './NavBarItem';

const MediaFactsURL = new URL('media-facts/', BlogURL);
const Title = PlanName[PlanType.Premium];

const MediaFactsItem = () => (
    <NavBarItem href={MediaFactsURL}>
        {Title}
    </NavBarItem>
);

export default MediaFactsItem;
